import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="feedback-form"
export default class extends Controller {
  static targets = ["feedbackForm", "hiddenFormField"]
  static values = { incompleteRatingsConfirm: String }

  submitForm(e) {
    e.preventDefault();

    const submitValue = e.currentTarget.value
    this.hiddenFormFieldTarget.value = submitValue;

    // Finalizing a feedback ("save") with missing ratings is unusual, so let
    // Turbo's native confirm dialog double-check the reviewer's intent. This
    // covers both no ratings at all and only some categories filled. Drafts skip it.
    if (submitValue === "save" && !this.allRatingsFilled) {
      this.feedbackFormTarget.setAttribute("data-turbo-confirm", this.incompleteRatingsConfirmValue);
    } else {
      this.feedbackFormTarget.removeAttribute("data-turbo-confirm");
    }

    this.feedbackFormTarget.requestSubmit();
  }

  get allRatingsFilled() {
    const radios = Array.from(this.feedbackFormTarget.querySelectorAll('input[type="radio"]'));
    const categories = new Set(radios.map(radio => radio.dataset.categoryName));
    const filledCategories = new Set(radios.filter(radio => radio.checked).map(radio => radio.dataset.categoryName));

    return categories.size > 0 && filledCategories.size === categories.size;
  }
}
